import React from 'react';
import { T } from '@transifex/react';

import { RoutingMap } from '../../../routing/utils';

export type HaulerNavEntry = {
  key: string;
  title: React.ReactNode;
  link: string;
};

export const createHaulerNavData = (
  routingMap: RoutingMap
): HaulerNavEntry[] => [
  // Dashboard is intentionally hidden until it earns its keep. The route still
  // exists at /hauler/dashboard if someone navigates there directly.
  {
    key: 'properties',
    title: <T _str="Properties" />,
    link: routingMap.hauler.properties._,
  },
  {
    key: 'tickets',
    title: <T _str="Tickets" />,
    link: routingMap.hauler.tickets._,
  },
  {
    key: 'messages',
    title: <T _str="Messages" />,
    link: routingMap.hauler.messages._,
  },
];
